import { z } from 'zod';
import {
  legalTeamSizeAllowedValues,
  licensedLawyerAllowedValues,
} from '@axiom/const';
import { ZodArrayToEnum } from '@axiom/types';

export const TalentInterviewLegalTeamQuestionsModalSchema = z.object({
  legalTeamSize: z.enum(ZodArrayToEnum(legalTeamSizeAllowedValues)),
  licensedLawyer: z.enum(ZodArrayToEnum(licensedLawyerAllowedValues)),
  licensedLawyerState: z.string(),
});

export type TalentInterviewLegalTeamQuestionsType = z.infer<
  typeof TalentInterviewLegalTeamQuestionsModalSchema
>;
